import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useFunnelVariant } from './useFunnelVariant';
import './mindrest.css';
import Hero from './sections/Hero';
import Problem from './sections/Problem';
import Rituals from './sections/Rituals';
import Offer from './sections/Offer';
import SocialProof from './sections/SocialProof';
import { FinalClose, FunnelFooter, FunnelHeader, StickyCta } from './sections/Chrome';

const SECTION_COMPONENTS = {
  problem: Problem,
  rituals: Rituals,
  offer: Offer,
  proof: SocialProof,
  close: FinalClose,
};

export default function FunnelPage() {
  const { variant: requested } = useParams();
  const variant = useFunnelVariant(requested);

  return (
    <div className="funnel mindrest min-h-screen bg-[#0A0A0A] font-jakarta text-white antialiased">
      <Helmet>
        <title>DepthMe — Train Your Inner Voice Daily</title>
        <meta
          name="description"
          content="DepthMe gives you personalized daily rituals to recognize thought patterns and train a new inner dialogue — guided in your own voice."
        />
        <meta name="theme-color" content="#0A0A0A" />
      </Helmet>

      {!variant ? (
        <div className="flex min-h-screen items-center justify-center" aria-busy="true">
          <img src="/brand/depthme-icon-192.png" alt="" className="h-14 w-14 animate-pulse rounded-full" />
        </div>
      ) : (
        <div data-variant={variant.key}>
          <FunnelHeader variant={variant} />
          <main>
            <Hero variant={variant} />
            {variant.sectionOrder.map((key) => {
              const Component = SECTION_COMPONENTS[key];
              return <Component key={key} variant={variant} />;
            })}
          </main>
          <FunnelFooter />
          <StickyCta variant={variant} />
        </div>
      )}
    </div>
  );
}
